import List from '@/views/agents/List'

export default [
  {
    path: '/agents',
    name: 'agents-list',
    component: List
  }
]